<template>
  <div class="home-page">
    <!-- 头部组件 -->
    <Header @tab-click="handleTabClick" @tab-fenlie-click="handleFenleiClick" :home="true" :activeName="activeName" @keyword="handleKeyword" />

    <!-- 主内容区域 -->
    <main class="content">
      <HomeBody :activeName="activeName" :activeFenleiName="String(activeFenleiName)" :keyword="keyword"
        @activeName_change="handleActiveNameChange" />
    </main>

    <!-- 底部组件 -->
    <Footer />
  </div>
</template>

<script>
// 导入头部组件
import Header from '../components/Header.vue'
// 导入底部组件
import Footer from '../components/Footer.vue'
// 导入首页主体组件
import HomeBody from '../components/HomeBody.vue'

export default {
  name: 'Home',
  components: {
    // 注册头部组件
    Header,
    // 注册底部组件
    Footer,
    // 注册首页主体组件
    HomeBody
  },
  data() {
    return {
      activeName: '1', // 默认值与Header组件一致
      activeFenleiName: '0', // 默认值与Header组件一致
      keyword: ''
    }
  },
  mounted() {
    this.activeName = this.$route.query.activeName || this.$route.params.activeName || '1'    
    // 页面加载完成后的逻辑
    // console.log('首页加载完成', '当前activeName:', this.activeName)
    this.getLocation()
  },
  methods: {
    handleTabClick(name) {
      this.activeName = String(name)
      // console.log('接收到Header传递的activeName:', name)
    },

    handleKeyword(keyword) {
      this.keyword = keyword
      console.log('接收到Header传递的keyword:', keyword)
    },

    handleFenleiClick(name) {
      this.activeFenleiName = String(name)
      // console.log('接收到Header传递的activeFenleiName:', name)
    },

    // 添加处理activeName_change事件的方法
    handleActiveNameChange(name) {
      this.activeName = String(name)
      // console.log('接收到HomeBody传递的activeName_change:', name)
    },

    getLocation() {
      // 1. 检查浏览器是否支持 Geolocation API
      if (!navigator.geolocation) {
        this.errorMsg = '当前浏览器不支持定位功能，请升级浏览器';
        return;
      }

      // 2. 请求定位权限并获取经纬度
      navigator.geolocation.getCurrentPosition(
        // 成功回调
        (position) => {
          this.errorMsg = '';
          // 核心数据：经度（longitude）、纬度（latitude）
          this.locationInfo = {
            lng: position.coords.longitude,
            lat: position.coords.latitude,
            // 可选：精度（米）、海拔等
            accuracy: position.coords.accuracy
          };
          console.log('定位成功：', this.locationInfo);

          localStorage.setItem('locationInfo', JSON.stringify(this.locationInfo));
        },
        // 失败回调（关键：处理各种定位失败场景）
        (error) => {
          const errorMap = {
            1: '用户拒绝了定位权限请求',
            2: '定位信息获取失败（设备未开启定位）',
            3: '定位请求超时'
          };
          this.errorMsg = errorMap[error.code] || `定位失败：${error.message}`;
          console.error('定位失败：', error);
        },
        // 可选配置项
        {
          enableHighAccuracy: true, // 高精度定位（耗时更长、耗电更多）
          timeout: 10000, // 超时时间（毫秒），默认 Infinity
          maximumAge: 0 // 缓存定位结果的时间（0 表示不缓存，每次都请求新数据）
        }
      );
    },

  }
}
</script>

<style scoped>
.home-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1;
  background-color: #f5f5f5;
}
</style>